import { render, staticRenderFns } from "./MyArticles.vue?vue&type=template&id=46aa8cc2&scoped=true"
import script from "./MyArticles.vue?vue&type=script&lang=js"
export * from "./MyArticles.vue?vue&type=script&lang=js"
import style0 from "./MyArticles.vue?vue&type=style&index=0&id=46aa8cc2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46aa8cc2",
  null
  
)

export default component.exports